import { render, staticRenderFns } from "./BenefitsType.vue?vue&type=template&id=1d3da7b4"
import script from "./BenefitsType.vue?vue&type=script&lang=js"
export * from "./BenefitsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports